import { TaxconformInput } from '../data/regFlowText';
import Navigation from '../components/navigation/navigation';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
import RadioInput from '../components/searchInputs/radioInput';
import { useSelector } from 'react-redux';

const TaxconForm = ({ handleNext, handleBack }) => {
  const companyStore = useSelector((state) => state.company_store);

  return (
    <div className='stepContainer'>
      <div className='SFInput'>
        <p className='SFSubTitle'>
          <span className='SFSubTitle'>
            {i18n.t('searchflow.taxconformlabel')}
          </span>{' '}
        </p>
        <RadioInput
          storeID='taxconform'
          dataText={TaxconformInput()}
          stateObject='company_store'
        />
      </div>

      <Navigation
        step={2}
        handleBack={() => handleBack()}
        handleNext={() => handleNext()}
        disabledProp={companyStore.taxconform !== '' ? false : true}
      />
    </div>
  );
};

export default withTranslation()(TaxconForm);
